import { Component } from '@angular/core';

@Component({
  selector: 'app-missing-nuvei',
  templateUrl: './missing-nuvei.component.html',
  styleUrls: ['./missing-nuvei.component.scss']
})
export class MissingNuveiComponent {

}
